import ConsentUtil from '@utils/ConsentUtil';
import posthog from 'posthog-js';
import Vue from 'vue';

let _initialized = false;
let _analytics_enabled = false;

export default {

    init() {
        if (_initialized || !process.env.VUE_APP_POSTHOG_KEY) return;

        const config = {
            api_host: process.env.VUE_APP_POSTHOG_HOST || 'https://us.i.posthog.com',
            capture_pageleave: true,
            capture_pageview: false,
            defaults: '2026-05-30',
        };

        if (ConsentUtil.isRequired()) {
            config.cookieless_mode = 'on_reject';
        }

        posthog.init(process.env.VUE_APP_POSTHOG_KEY, config);

        posthog.register({ env: process.env.VUE_APP_ENV || 'production' });

        Vue.prototype.$posthog = posthog;
        _initialized = true;

        if (!ConsentUtil.isRequired()) {
            _analytics_enabled = true;
        }
    },

    enableAnalytics() {
        if (!_initialized) return;

        if (!ConsentUtil.isRequired()) {
            _analytics_enabled = true;
            return;
        }

        posthog.opt_in_capturing();
        _analytics_enabled = true;
    },

    disableAnalytics() {
        if (!_initialized || !ConsentUtil.isRequired()) return;

        posthog.opt_out_capturing();
        _analytics_enabled = false;
    },

    pageview() {
        if (!_initialized) return;
        posthog.capture('$pageview');
    },

    identify(user) {
        if (!_initialized || !user?.uuid || !_analytics_enabled) return;
        posthog.identify(user.uuid, {
            billing_status: user.billing_status,
            email: user.email,
            env: process.env.VUE_APP_ENV || 'production',
            first_name: user.first_name,
            is_sub_account: user.is_sub_account,
            last_name: user.last_name,
            signed_up_at: user.created_at,
            user_id: user.id,
        });
    },

    reset() {
        if (!_initialized) return;
        posthog.reset();
    },

};
